"use client";

import React, { useState } from "react";
import { format } from "date-fns";

import { Button } from "ui/components/button";
import { Popover, PopoverContent, PopoverTrigger } from "ui/components/popover";

import { MonthPicker } from "ui/components/monthpicker";
import { Icon } from "components/index";
import { X } from "icons/src";
import classNames from "classnames";

export function MonthPickerButton({
  selectedMonth,
  onMonthSelect,
  onClear,
  placeholder = "Select month",
  className = "",
  disabled = false,
  showClearButton = true,
  ...props
}) {
  const [isOpen, setIsOpen] = useState(false);

  const handleMonthSelect = (month) => {
    // Convert to start of selected month
    const startOfMonth = new Date(month.getFullYear(), month.getMonth(), 1);
    onMonthSelect?.(startOfMonth);
    setIsOpen(false);
  };

  const handleClear = (e) => {
    e.stopPropagation();
    onClear?.();
  };

  const formatSelectedMonth = (month) => {
    if (!month) return placeholder;
    return format(month, "MMM yyyy");
  };

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          className={`w-full justify-start text-left font-normal px-3 ${className}`}
          disabled={disabled}
          {...props}
        >
          <span className={classNames("flex-1", { "text-muted-foreground": !selectedMonth })}>{formatSelectedMonth(selectedMonth)}</span>
          {showClearButton && selectedMonth && (
            <div as="button" onClick={handleClear}>
              <Icon
                icon={X}
                className="ml-2 h-4 w-4 hover:bg-muted rounded-sm p-0.5"
              />
            </div>
          )}
        </Button>
      </PopoverTrigger>
      <HeaderPortal>
        <PopoverContent className="w-auto p-0" align="start">
          <MonthPicker
            selectedMonth={selectedMonth}
            onMonthSelect={handleMonthSelect}
          />
        </PopoverContent>
      </HeaderPortal>
    </Popover>
  );
}
